module.exports = __webpack_public_path__ + "img/end-shift.99dd41fd.svg";